import { AiOutlineCheckCircle } from "react-icons/ai";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import '../container/sidebar.css'
import i18n from "../../translations/I18n";

const obj = {

    tb1_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>Category</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Description</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Service</p>",
            },

        ]
    },
    tb1_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Event Sourcing</p>",
            },
            {
                title: "<p class='typo-14'>Event-driven architecture, large-scale distributed systems, Event Store operation, serverless type</p>",
            },
            {
                title: "<p class='typo-14'>Event Sourcing</p>",
            },

        ],
        row_2: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Identity and Access Management</p>",
            },
            {
                title: "<p class='typo-14'>Operating an Identity Provider, managing client IDs, performing identification and authentication</p>",
            },
            {
                title: "<p class='typo-14'>Open ID Connect</p>",
            },


        ],
        row_3: [
            {
                title: "<p class='typo-14'>Building OAuth Server/Client for delegated authorization and access control</p>",
            },
            {
                title: "<p class='typo-14'>OAuth</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14'>Grouping of IDs and organizational structure management</p>",
            },
            {
                title: "<p class='typo-14'>Directory</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14'>Assigning read, write, and delete permissions of objects to Roles and generating Access Control Lists</p>",
            },
            {
                title: "<p class='typo-14'>Role based <br> Access Management</p>",
            },

        ],
        row_6: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Messaging</p>",
            },
            {
                title: "<p class='typo-14'>Publisher defines and registers a message as a topic and broadcasts it to Subscribers</p>",
            },
            {
                title: "<p class='typo-14'>Topics</p>",
            },

        ],
        row_7: [
            {
                title: "<p class='typo-14'>Filtering received message topics and storing them in a queue per Subscriber for management</p>",
            },
            {
                title: "<p class='typo-14'>Queues</p>",
            },

        ],
        row_8: [
            {
                title: "<p class='typo-14'>Registering a server-side event trigger to push notifications to an external endpoint</p>",
            },
            {
                title: "<p class='typo-14'>Webhooks</p>",
            },

        ],
        row_9: [
            {
                title: "<p class='typo-14'>Support for Linux Cron format, used in applications and processes</p>",
            },
            {
                title: "<p class='typo-14'>Scheduler</p>",
            },

        ],
        row_10: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Web RPC</p>",
            },
            {
                title: "<p class='typo-14'>Unary, Streaming (WebSocket: Server/Client Bidirectional), Client TypeScript (for Streaming use)</p>",
            },
            {
                title: "<p class='typo-14'>WebRPC</p>",
            },

        ],
        row_11: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Long-running</p>",
            },
            {
                title: "<p class='typo-14'>Asynchronous CUD operations in Event Sourcing modules, separate server response and page navigation</p>",
            },
            {
                title: "<p class='typo-14'>Long-running</p>",
            },

        ],
        row_12: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Storage (S3)</p>",
            },
            {
                title: "<p class='typo-14'>Directly storing all uploaded files generated in the cloud into Object Storage</p>",
            },
            {
                title: "<p class='typo-14'>Core Storage</p>",
            },

        ],
        row_13: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Email</p>",
            },
            {
                title: "<p class='typo-14'>Bulk sending of outgoing email in the cloud and providing a reporting dashboard</p>",
            },
            {
                title: "<p class='typo-14'>Vora Email</p>",
            },

        ],
        row_14: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Process(Workflow)</p>",
            },
            {
                title: "<p class='typo-14'>Business automation, automatic status changes, and automatic task assignment to responsible users</p>",
            },
            {
                title: "<p class='typo-14'>Business Process</p>",
            },

        ],
        row_15: [
            {
                title: "<p class='typo-14'>Automatic processes triggered by clicks within linked sites from sent Email/SMS</p>",
            },
            {
                title: "<p class='typo-14'>Journey Process</p>",
            },

        ],
        row_16: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Rule</p>",
            },
            {
                title: "<p class='typo-14'>Automatically executed by triggers, taking action based on whether criteria is True/False</p>",
            },
            {
                title: "<p class='typo-14'>Automation Rule</p>",
            },

        ],
        row_17: [
            {
                title: "<p class='typo-14'>Automatically assigning responsible users based on predefined rules</p>",
            },
            {
                title: "<p class='typo-14'>Assignment Rule</p>",
            },

        ],
        row_18: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Rate Limiting</p>",
            },
            {
                title: "<p class='typo-14'>Protecting applications against surges in unstable and unpredictable client requests</p>",
            },
            {
                title: "<p class='typo-14'>Rate Limiting</p>",
            },

        ],
        row_19: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Simple URL shortner</p>",
            },
            {
                title: "<p class='typo-14'>Shortening long URLs into personalized short URLs with recipient tracking and reporting</p>",
            },
            {
                title: "<p class='typo-14'>SUS</p>",
            },

        ]
    },

    tb2_header: {
        row_1: [
            {
                title: "",
            },
            {
                title: "",
            },

        ]
    },
    tb2_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Identity</p>",
            },
            {
                title: "<p class='typo-14'>Presenting the identity of a principal — such as a username or account number</p>",
            },

        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authentication</p>",
            },
            {
                title: "<p class='typo-14'>Verifying that the presented identity is valid — using a password, biometric data, smart card, etc.</p>",
            },

        ],
        row_3: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authorization</p>",
            },
            {
                title: "<p class='typo-14'>The process of granting access to a specific object (resource)</p><p class='typo-14'>-- Access Control List (ACL): A list that defines permissions for users or roles</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Access Control</p>",
            },
            {
                title: "<p class='typo-14'>Controlling access to specific systems or information for users who have passed through identification, authentication, and authorization</p><p class='typo-14'>Access Control Types: Supports multiple types, including RBAC (Role-Based Access Control)</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>RBAC (Role-Based Access Control)</p>",
            },
            {
                title: "<p class='typo-14'>A Role is assigned to a Principal (user or entity) for access to a Resource,</p><p class='typo-14'>and each Role is pre-defined with specific Permissions for that resource.</p><p class='typo-14'> Permissions: Write / Delete / Update / List / Get</p>",
            },

        ],
        row_6: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>IdP (ID Provider)</p>",
            },
            {
                title: "<p class='typo-14'>An Identity Provider (IdP) is responsible for creating, storing, and managing digital identities.</p><p class='typo-14'>It can either authenticate users directly or provide authentication to third-party Service Providers (SPs) — such as Google or Facebook.</p>",
            },

        ],
    },

    tb3_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>Category</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Access Token (OAuth)</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>ID Token (OIDC)</p>",
            },
        ]
    },
    tb3_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Resource Access Permissions</p>",
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>User Identity Information</p>",
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
        ],
    },

    tb4_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb4_content: {
        row_1: [
            {
                title: "API 요청",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },
    tb5_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb5_content: {
        row_1: [
            {
                title: "Event Store",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb6_header: {
        row_1: [
            {
                title: "항n",
            },
            {
                title: "건 (월비용)",
            },
            {
                title: "가격(원)",
            },

        ]
    },
    tb6_content: {
        row_1: [
            {
                title: "클라우드 내부간 Push",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_2: [
            {
                rowSpan: "2",
                title: "외부 Push",
            },
            {
                title: "백만 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_3: [
            {
                title: "이후 십만건당",
            },
            {
                title: "1,000 원",
            },

        ],
    },

    tb7_header: {
        row_1: [
            {
                Cols50: "True",
                title: "<p class='typo-14 typo-medium typo-white'>Standard Approach</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Long-running Approach</p>",
            },
        ],
    },
    tb7_content: {
        row_1: [
            {
                bold: "False",
                title: "<p class='typo-14'>All code executes synchronously, running in sequence.</p><p class='typo-14'>Each operation waits for the previous one to finish before proceeding.</p>",
            },
            {
                title: "<p class='typo-14'>When processing code asynchronously, tasks are handled in the background on the server.</p><p class='typo-14'> The system proceeds to the next operation without waiting for the current task to complete.</p>",
            },
        ],
    },

    tb8_header: {
        row_1: [
            {
                title: "항옥",
            },
            {
                title: "API 사용건",
            },
            {
                title: "웹 접속건",
            },
            {
                title: "가격(원)",
            },
        ],
    },
    tb8_content: {
        row_1: [
            {
                title: "클라우드 사용고객",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "외부 - Vora Works",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb9_header: {
        row_1: [
            {
                title: "&nbsp;",
            },
            {
                title: "Topic",
            },
            {
                title: "Queue",
            },
            {
                title: "Channel",
            },
        ],
    },
    tb9_content: {
        row_1: [
            {
                title: "Delivery",
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Committing Offset 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Ack Reply 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Most Once</div>",
            }
        ],
        row_2: [
            {
                title: "Storage",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>In Memory</div>",
            },
        ],
        row_3: [
            {
                title: "Ordering",
            },
            {
                title: "<div style='text-align:center'>순서보장</div>",
            },
            {
                title: "<div style='text-align:center'>순서보장안함</div>",
            },
            {
                title: "<div style='text-align:center'>X</div>",
            },
        ],
        row_4: [
            {
                title: "Consumer",
            },
            {
                title: "<div style='text-align:center'>Pub / Sub</div>",
            },
            {
                title: "<div style='text-align:center'>1:1</div>",
            },
            {
                title: "<div style='text-align:center'>Fan Out (Broadcast)</div>",
            },
        ],
    },
    tb10_header: {
        row_1: [
            {
                Cols50: "True",
                title: "Pull"
            },
            {
                title: "Push"
            },
        ],
    },
    tb10_content: {
        row_1: [
            {
                bold: "False",
                title: "<div style='text-align:'>Streaming Pull 지원. <br> Consumer 가 API 를 호출해서 Message 를 가져감.</div>"
            },
            {
                title: "<div style='text-align:'>Worker가 Message를 받아 GRPC Unary나 URL Get/Post를 보냄.</div>"
            }
        ]
    },
};


export default obj;